import { useCallback, useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { Toaster } from "sonner";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Films from "./components/Films";
import About from "./components/About";
import Gallery from "./components/Gallery";
import Footer from "./components/Footer";

function App() {
    const lenisRef = useRef(null);
    const [locked, setLocked] = useState(false);
    const [showTop, setShowTop] = useState(false);

    // Scroll con momentum (Lenis)
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        lenisRef.current = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    useEffect(() => {
        const lenis = lenisRef.current;
        if (!lenis) return;
        locked ? lenis.stop() : lenis.start();
    }, [locked]);

    useEffect(() => {
        const onScroll = () => setShowTop(window.scrollY > 700);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollTo = useCallback((target) => {
        lenisRef.current?.scrollTo(target, { offset: -64, duration: 1.4 });
    }, []);

    return (
        <div className="min-h-screen bg-[#FAF8F5] text-[#141312]">
            <Nav scrollTo={scrollTo} />
            <main>
                <Hero scrollTo={scrollTo} />
                <Films setLocked={setLocked} />
                <About />
                <Gallery setLocked={setLocked} />
            </main>
            <Footer />
            <Toaster position="bottom-center" toastOptions={{ style: { background: "#141312", color: "#FAF8F5", border: "none" } }} />

            {/* Volver arriba */}
            <AnimatePresence>
                {showTop && (
                    <motion.button
                        initial={{ opacity: 0, y: 16 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 16 }}
                        transition={{ duration: 0.3 }}
                        onClick={() => scrollTo(0)}
                        className="fixed bottom-6 right-6 z-[65] rounded-full border border-[#E5E0D5] bg-[#FAF8F5]/90 p-3.5 text-[#141312] shadow-lg backdrop-blur-md transition-colors duration-300 hover:bg-[#6B1D2F] hover:text-[#FAF8F5]"
                        aria-label="Volver arriba"
                        data-testid="back-to-top"
                    >
                        <ArrowUp size={18} />
                    </motion.button>
                )}
            </AnimatePresence>
        </div>
    );
}

export default App;
